import type { TFunction } from 'i18next'

import type { SearchResult } from '@cash-web/support/feature-main'

const getRecommendedArticles = (t: TFunction): SearchResult[] => [
  {
    document_id: 'cash-help-article-3130',
    title: t('Access Old Account', { context: 'Title for recommended article: "Access Old Account"' }),
    preview: t(
      'If you are having trouble accessing an old account, it may be associated with another phone or email address.',
      { context: 'Preview for recommended article: "Access Old Account"' }
    ),
    url: 'http://cash.app/help/3130',
  },
  {
    document_id: 'cash-help-article-3074',
    title: t("Withdrawal wasn't Instant", { context: 'Title for recommended article: "Withdrawal wasn\'t Instant"' }),
    preview: t("If your debit card doesn't accept Instant Deposit, you will be refunded any Instant Deposit fees", {
      context: 'Preview for recommended article: "Withdrawal wasn\'t Instant"',
    }),
    url: 'https://cash.app/help/us/en-us/3074-cash-out-not-instant',
  },
  {
    document_id: 'cash-help-article-3123',
    title: t('What is a $Cashtag?', { context: 'Title for recommended article: "What is a $Cashtag?"' }),
    preview: t('A $Cashtag is a unique identifier for individuals and businesses using Cash App', {
      context: 'Preview for recommended article: "What is a $Cashtag?"',
    }),
    url: 'https://cash.app/help/us/en-us/3123-cashtags',
  },
  {
    document_id: 'cash-help-article-3051',
    title: t('Canceling a Payment', { context: 'Title for recommended article: "Canceling a Payment"' }),
    preview: t("Cash App payments are instant and usually can't be canceled.", {
      context: 'Preview for recommended article: "Canceling a Payment"',
    }),
    url: 'https://cash.app/help/us/en-us/3051-cancel-a-payment',
  },
]

export default getRecommendedArticles
